<template>
  <div class="playback-container" :class="playback.size">
    <iframe
      :src="playback.url"
      scrolling="no"
      frameborder="0" >
    </iframe>
  </div>
</template>

<script>
export default {
  name: 'playbackEmbed',
  props: ['playback']
}
</script>

<style scoped>
.playback-container {
  padding-bottom: 75%;
  position: relative;
  margin-top: 1.5em;
}

.playback-container.narrow {
  padding-bottom: 28.5%;
}

.playback-container.widescreen {
  padding-bottom: 56.25%;
}

.playback-container.square {
  padding-bottom: 100%;
}

.playback-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PlaybackEmbed.vue?057b6d38